module.exports = __webpack_public_path__ + "img/14.62a7f5b0.png";